import glamExampleOne from '../assets/images/examples/939db7dd-faa1-46c6-89c8-fcaceb45c6d1.jpg';
import glamExampleTwo from '../assets/images/examples/Home_person.jpg';
import glamExampleThree from '../assets/images/examples/cdba80a0-5f6e-41da-b772-5cb1d7800b4b.jpg';

export const workImageSources = [glamExampleOne, glamExampleTwo, glamExampleThree] as const;
